export default __webpack_public_path__ + "static/indoor17-170825facbcb04a105db2ac92e9ecfcc.webp";